import { memo } from 'react';

import PrescriptionCard from '../PrescriptionCard';

import { Props } from './types';

const PersonMedicationsList = ({ medications }: Props) => {
  return (
    <ul className="space-y-4">
      {medications.length === 0 && <li>No prescriptions found.</li>}
      {medications.length > 0 && (
        <>
          {medications.map((medication) => {
            return (
              <li key={medication.id} data-testid="medication-list-item">
                <PrescriptionCard prescription={medication} />
              </li>
            );
          })}
        </>
      )}
    </ul>
  );
};

export default memo(PersonMedicationsList);
